export default __webpack_public_path__ + "static/media/section5-pic2.a276a815.png";